<template>
  <div>
    <UtteranceControl
      v-bind="$attrs"
      :disabled-enter="disabled"
      :customEndter="true"
      v-on="$listeners"
      @disabledEnter="handelDisabledEnter"
      @enter="handelEnter"
    ></UtteranceControl>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';
import { namespace } from 'vuex-class';
import { Content } from '@forchange/storytime'
const videoModal = namespace('video');

@Component({
  components: {
    UtteranceControl
  }
})
export default class CascaderControl extends Vue {
  @Prop({ type: Object }) content!: Content & {
    requireReading: boolean | string;
  };
  @videoModal.State('isEnd') isEnd: boolean;
  
  get disabled() {
    return ['是', true].includes(this.content.requireReading) ? !this.isEnd : false
  }

  handelDisabledEnter() {
    this.$Message.warn({
      time: 1500,
      content: '请先完成视频观看再继续'
    });
  }

  handelEnter() {
    this.$store.commit('video/clear');
    window.next();
    this.$emit('next');
  }
}
</script>
